<template>
  <v-flex xl6 md6 sm12 xs12 pl-0 ml-0>
    <v-layout column justify-center>
      <v-flex xl6 md6 sm12 xs12 class="text-center">
        <h3 class="display-2">{{ $t('select_date') }}</h3>
      </v-flex>
      <v-flex xl6 md6 sm12 xs12 text-center>
        <v-layout row p0 m0 border>
          <v-flex text-left><v-btn class="l-btn v-btn v-btn--flat v-btn--floating theme--light"></v-btn> - {{ $t("select_avaliable") }}</v-flex>
          <v-flex text-left><v-btn class="l-btn v-btn v-btn--active v-btn--icon v-btn--floating theme--light blue"></v-btn> - {{ $t("selected") }}</v-flex>
          <!--<v-flex><v-btn class="l-btn v-btn v-btn--flat v-btn--floating v-btn--disabled theme--light">&nbsp;&nbsp;</v-btn> - {{ $t("select_unavaliable") }}</v-flex>
        --></v-layout>
      </v-flex>
      <v-flex xl6 md6 sm12 xs12>
        <v-date-picker
          :color="this.$vuetify.theme.primary"
          v-model="picker"
          no-title
          :landscape="landscape"
          full-width
          :locale="$i18n.locale"
          :allowed-dates="allowedDates"
          :min="period.start"
          :max="period.end"
          :first-day-of-week="1"
          @input="dateChanged"
        ></v-date-picker>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
export default {
  name: "rDateLoader",
  props: ["dates", "period", "selected"],
  data: function() {
    return {
      picker: new Date(
        this.selected
          .split("/")
          .reverse()
          .join("-")
      )
        .toISOString()
        .substr(0, 10),
      landscape: false
    };
  },
  methods: {
    allowedDates: function(val) {
      return this.dates.includes(
        new Date(val).toLocaleDateString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        })
      );
    },
    dateChanged: function(event) {
      this.$emit("dateChanged", event);
    }
  },
  created: function () {
    this.$emit("dateChanged", this.picker);
  }
};
</script>

<style>
button {
  font-size: 20px !important;
  border-radius: 0 !important;
}

.l-btn {
  max-width: 32px;
  max-height: 32px;
}

.v-btn--flat:not(.v-btn--disabled){
  background-color: var(--v-primary-base) !important;
  color: white !important;
}

.v-btn--active{
  background-color: var(--v-accent-base) !important;
  color: black !important;
}
</style>